export default "__VITE_ASSET__G$qjk25B__"